import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import * as React from "react";
import { useState } from "react";
import { Button, Create, SelectArrayInput, Toolbar, required, useDataProvider, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { SectionTitle } from "../../../../../src/Components/SectionTitle";
import { Separator } from "../../../../../src/Components/Separator";
import { PbhRequestOrderTabEnum } from "../../../../../src/Enums/PbhRequestOrderTabEnum";
import { PbhRequestStatus } from "../../../../../src/Enums/PbhRequestStatus";
import { useAppDataProvider } from "../../../../../src/dataprovider";
import AlternatePnCreateNewItem from "./AlternatePnCreateNewItem";

const useStyles = makeStyles({
  toolbar: {
    flex: "auto",
    justifyContent: "center",
    backgroundColor: "white",
  },
  defaultToolbar: {
    flex: "auto",
    justifyContent: "center",
  },
});

const PbhRequestAlternatePnCreate = props => {
  const [alternatePnList, setAlternatePnList] = useState([] as any);
  const provider = useDataProvider();
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();

  const classes = useStyles();

  const requestId = props.requestId;

  React.useEffect(() => {
    getAlternatePnList();
  }, [requestId]);

  const getAlternatePnList = async () => {
    const { data } = await provider.getList("invpngs/getcustomlist", {
      pagination: {
        page: 1,
        perPage: 5 + (props?.requestDetail?.alternatePn.length ?? 0),
      },
      sort: { field: "id", order: "DESC" },
      filter: {
        pn__eq: props.requestDetail.pn,
      },
    });
    if (data.length > 0) {
      const requestAlternatePns = props?.requestAlternatePn?.map?.(x => x.alternatePn) || [];

      let mappedData = data
        ?.map?.(item => ({
          id: item.pn,
          pn: item.pn,
        }))
        ?.filter?.(pn => !requestAlternatePns?.includes?.(pn.pn));
      setAlternatePnList(mappedData);
    }
  };

  const CreateAlternateButtonClick = async e => {
    await CreateAlternatePn(e).then(() => {
      history.push("/pbhrequestorders/" + requestId + "/" + Number(PbhRequestOrderTabEnum.AltenatePn));
    });
  };

  const CreateAlternatePn = async e => {
    setLoading(true);
    var requestAlternatePnsModel = e?.alternatePn?.map?.(element => ({
      RequestId: requestId,
      AlternatePn: element,
      Status: PbhRequestStatus.AlternatePnOffered,
    }));

    dataProvider
      .postBulkPbhRequestAlternatePn(requestAlternatePnsModel)
      .then(result => {
        props.finalCallBack();
        notify("Alternate PN offered", "success", false, true);
      })
      .catch(result => {
        notify(`${result}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form
      onSubmit={CreateAlternateButtonClick}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Grid container direction="row" item xs={12} spacing={1} justifyContent="center" alignItems="center">
                    <SectionTitle label={"Alternate Pn Info"} />
                  </Grid>
                  <Separator />
                  <Grid
                    container
                    direction="row"
                    xs={12}
                    spacing={1}
                    item
                    justifyContent="center"
                    alignItems="center"
                    style={{
                      padding: "10px",
                    }}
                  >
                    <Grid item xs={12} sm={8}>
                      <SelectArrayInput
                        createLabel={"Create New Alternate Pn"}
                        create={<AlternatePnCreateNewItem choices={alternatePnList} />}
                        source="alternatePn"
                        choices={alternatePnList}
                        disabled={props?.readonly}
                        optionText="pn"
                        optionValue="id"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Separator />
                    <Toolbar {...props} placeholder="" classes={classes}>
                      <Button
                        label={"Offer Alternate PN"}
                        disabled={loading || props?.readonly}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                      </Button>
                    </Toolbar>
                  </Grid>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default PbhRequestAlternatePnCreate;
